"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConverDataFromStoreToCreateMapUpdateObject = exports.ConvertStandardDataDisplayProperyToControlDataSource = exports.ConvertFilterStandardPropertyToControlForm = exports.ConvertDisplayStandardPropertyToControlForm = exports.CreateDefaultDisplayStandardObjec = exports.getTableNameFormUrl = exports.MergeLayerDisplayStandardData = exports.MergeFilterStandardData = exports.MergeLayerPropertyToStandardObject = exports.CreateUpdateLayerFilterObject = exports.CreateLayerFilterObjectDefault = exports.CreateUpdateLayerDisplayInfomationSettingObject = exports.CreateLayerDisplayInfomationSettingObjectDefault = exports.CreateListPropertyFromDataSourec = exports.CreateLayerSettingObject = exports.ExchangeColsDataSoure = exports.CreateDataSourceObject = void 0;
function CreateDataSourceObject(tableName, cols, wms, style, wmsParameters, wms_external) {
    if (tableName === void 0) { tableName = null; }
    if (cols === void 0) { cols = null; }
    if (wms === void 0) { wms = null; }
    if (style === void 0) { style = null; }
    if (wmsParameters === void 0) { wmsParameters = null; }
    if (wms_external === void 0) { wms_external = false; }
    return {
        tableName: tableName || "",
        cols: ExchangeColsDataSoure(cols),
        wms: wms || "",
        style: style || "",
        wmsParameters: wmsParameters || "",
        wms_external: wms_external,
    };
}
exports.CreateDataSourceObject = CreateDataSourceObject;
function ExchangeColsDataSoure(cols) {
    var result = [];
    if (cols)
        cols.map(function (col) { return result.push(__assign(__assign({}, col), { label: col.column_name })); });
    return result;
}
exports.ExchangeColsDataSoure = ExchangeColsDataSoure;
function CreateLayerSettingObject(layerName, minZoom, maxZoom, zIndex, defaultTurnOn, isTiffLayer, layer_kind) {
    if (layerName === void 0) { layerName = ""; }
    if (minZoom === void 0) { minZoom = 0; }
    if (maxZoom === void 0) { maxZoom = 20; }
    if (zIndex === void 0) { zIndex = 1; }
    if (defaultTurnOn === void 0) { defaultTurnOn = false; }
    if (isTiffLayer === void 0) { isTiffLayer = false; }
    return {
        layerName: layerName,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zIndex: zIndex,
        defaultTurnOn: defaultTurnOn,
        isTiffLayer: isTiffLayer,
        layer_kind: layer_kind,
    };
}
exports.CreateLayerSettingObject = CreateLayerSettingObject;
function CreateListPropertyFromDataSourec(dataSource) {
    var result = [];
    dataSource.cols.map(function (cols) {
        return result.push(CreateObjectOfArrayListItem(cols.column_name, cols.data_type, cols.column_name, false));
    });
    return result;
}
exports.CreateListPropertyFromDataSourec = CreateListPropertyFromDataSourec;
function CreateLayerDisplayInfomationSettingObjectDefault(dataSource) {
    return ({
        viewDetail: CreateListPropertyFromDataSourec(dataSource),
        tooltip: CreateListPropertyFromDataSourec(dataSource),
        popup: CreateListPropertyFromDataSourec(dataSource),
    });
}
exports.CreateLayerDisplayInfomationSettingObjectDefault = CreateLayerDisplayInfomationSettingObjectDefault;
function CreateUpdateLayerDisplayInfomationSettingObject(viewDetail, tooltip, popup) {
    return ({
        viewDetail: viewDetail,
        tooltip: tooltip,
        popup: popup,
    });
}
exports.CreateUpdateLayerDisplayInfomationSettingObject = CreateUpdateLayerDisplayInfomationSettingObject;
function CreateLayerFilterObjectDefault(dataSource) {
    return {
        input: CreateListPropertyFromDataSourec(dataSource),
        output: CreateListPropertyFromDataSourec(dataSource),
        sortKeyword: "",
    };
}
exports.CreateLayerFilterObjectDefault = CreateLayerFilterObjectDefault;
function CreateUpdateLayerFilterObject(input, output, sortKeyword) {
    return ({
        input: input,
        output: output,
        sortKeyword: sortKeyword,
    });
}
exports.CreateUpdateLayerFilterObject = CreateUpdateLayerFilterObject;
function MergeLayerPropertyToStandardObject(dataSource, layerSetting, layerViewSetting, layerFilterSetting) {
    return {
        display: MergeLayerDisplayStandardData(dataSource, layerViewSetting),
        filter: MergeFilterStandardData(layerFilterSetting),
        geo_layer_name: layerSetting.layerName,
        id: 0,
        is_check: layerSetting.defaultTurnOn,
        layer_category_id: 0,
        layer_type: "wms",
        level: 1,
        max_zoom: layerSetting.maxZoom,
        min_zoom: layerSetting.minZoom,
        name: layerSetting.layerName,
        table: dataSource.tableName,
        wms: dataSource.wms,
        wms_external: dataSource.wms_external,
        z_index: layerSetting.zIndex,
        is_tiff_layer: layerSetting.isTiffLayer,
        layer_kind: layerSetting.layer_kind,
    };
}
exports.MergeLayerPropertyToStandardObject = MergeLayerPropertyToStandardObject;
function MergeFilterStandardData(layerFilterSetting) {
    function CollectCheckedColumn(listData) {
        var result = [];
        listData.map(function (data) {
            if (data.checked)
                result.push(CreateStandardObjectOfFilterArray(data.column_name, data.label, data.data_type, data.type_display));
        });
        return result;
    }
    return ({
        in: CollectCheckedColumn(layerFilterSetting.input),
        order: layerFilterSetting.sortKeyword,
        out: CollectCheckedColumn(layerFilterSetting.output),
    });
}
exports.MergeFilterStandardData = MergeFilterStandardData;
function MergeLayerDisplayStandardData(dataSource, layerViewSetting) {
    function CollectCheckedColumn(listData) {
        var result = [];
        listData.map(function (data) {
            if (data.checked) {
                result.push(data.column_name);
                return;
            }
        });
        return result;
    }
    var ViewDetail = CollectCheckedColumn(layerViewSetting.viewDetail);
    var Tooltip = CollectCheckedColumn(layerViewSetting.tooltip);
    var Popup = CollectCheckedColumn(layerViewSetting.popup);
    var cols = [];
    dataSource.cols.map(function (col, index) {
        return cols.push({
            col: col.column_name,
            alias: col.label,
            index: index,
            kieu: col.data_type,
        });
    });
    return ({
        viewdetail: {
            cols: ViewDetail,
            use: ViewDetail.length > 0 ? true : false,
        },
        cols: cols,
        popup: {
            cols: Popup,
            use: Popup.length > 0 ? true : false,
        },
        tooltip: {
            cols: Tooltip,
            use: Tooltip.length > 0 ? true : false,
        },
    });
}
exports.MergeLayerDisplayStandardData = MergeLayerDisplayStandardData;
exports.getTableNameFormUrl = function (urlWms) {
    var StringArray = urlWms.split(":");
    return StringArray.pop();
};
exports.CreateDefaultDisplayStandardObjec = function (dataSourceCols) {
    var cols = [];
    dataSourceCols.map(function (col, index) {
        return cols.push({
            col: col.column_name,
            alias: col.label,
            index: index,
            kieu: col.data_type,
        });
    });
    return {
        viewdetail: {
            use: false,
            cols: [],
        },
        popup: {
            use: false,
            cols: [],
        },
        tooltip: {
            use: false,
            cols: [],
        },
        cols: cols,
    };
};
exports.ConvertDisplayStandardPropertyToControlForm = function (propertyCols, dataSourceCols) {
    var ListChecked = [];
    var ListUnChecked = [];
    var isColumnSelected = function (col) {
        var checked = false;
        propertyCols.map(function (column) {
            if (col.col === column) {
                checked = true;
                return;
            }
        });
        return checked;
    };
    var sortListChecked = function () {
        var result = [];
        propertyCols.map(function (column) {
            ListChecked.map(function (data) {
                if (data.column_name === column) {
                    result.push(__assign({}, data));
                    return;
                }
            });
        });
        return result;
    };
    dataSourceCols.map(function (dataCols) {
        if (isColumnSelected(dataCols))
            ListChecked.push(CreateObjectOfArrayListItem(dataCols.col, dataCols.kieu, dataCols.alias, true));
        else
            ListUnChecked.push(CreateObjectOfArrayListItem(dataCols.col, dataCols.kieu, dataCols.alias, false));
    });
    return __spreadArrays(sortListChecked(), ListUnChecked);
};
exports.ConvertFilterStandardPropertyToControlForm = function (propertyCols, dataSourceCols) {
    var isColsHasChecked = function (col) {
        var result = -1;
        propertyCols.map(function (colChecked, index) {
            if (colChecked.col === col.column_name) {
                result = index;
                return;
            }
        });
        return result;
    };
    var ListChecked = [];
    var ListUnChecked = [];
    dataSourceCols.map(function (dataCols) {
        var indexChecked = isColsHasChecked(dataCols);
        if (indexChecked != -1) {
            var ColChecked = propertyCols[indexChecked];
            ListChecked.push(CreateFilterAtomObjectFromLayerStandardData(ColChecked.col, ColChecked.alias, ColChecked.kieu, true, ColChecked.type_display || ''));
        }
        else {
            ListUnChecked.push(CreateFilterAtomObjectFromLayerStandardData(dataCols.column_name, dataCols.column_name, dataCols.data_type, false, dataCols.type_display || ''));
        }
    });
    return __spreadArrays(ListChecked, ListUnChecked);
};
exports.ConvertStandardDataDisplayProperyToControlDataSource = function (standardData) {
    var cols = [];
    standardData.cols.map(function (col) {
        return cols.push(CreateObjectOfColsOfTableRaw(col.col, col.alias, col.kieu));
    });
    return { cols: cols };
};
exports.ConverDataFromStoreToCreateMapUpdateObject = function (initMapState) {
    var mapSetting = initMapState.mapSetting;
    var BaseMap = initMapState.baseMaps;
    var Layers = initMapState.layers;
    function ConverMapSettingArrayElement(id, map_id, name, type_map, layer_categories, base_maps) {
        if (layer_categories === void 0) { layer_categories = []; }
        if (base_maps === void 0) { base_maps = []; }
        layer_categories.map(function (layerGroup, index) {
            layerGroup.level = index;
        });
        return {
            id: id,
            map_id: map_id,
            name: name,
            type_map: type_map,
            layer_categories: layer_categories,
            base_maps: base_maps,
        };
    }
    return {
        id: mapSetting.id,
        planing_id: mapSetting.planing_id,
        name: mapSetting.name,
        z_index: mapSetting.z_index,
        zoom: mapSetting.zoom,
        min_zoom: mapSetting.min_zoom,
        max_zoom: mapSetting.max_zoom,
        projection: mapSetting.projection,
        extent: mapSetting.extent.join(),
        center: mapSetting.center.join(),
        is_active: mapSetting.is_active,
        map_setting: [
            ConverMapSettingArrayElement(BaseMap.id, BaseMap.map_id, BaseMap.name, BaseMap.type_map, [], BaseMap.base_maps),
            ConverMapSettingArrayElement(Layers.id, Layers.map_id, Layers.name, Layers.type_map, Layers.layer_categories, []),
        ],
    };
};
//--- create atom object
var CreateFilterAtomObjectFromLayerStandardData = function (colName, colLabel, colType, checked, type_display) { return ({
    column_name: colName,
    data_type: colType,
    label: colLabel,
    checked: checked,
    type_display: type_display
}); };
var CreateObjectOfColsOfTableRaw = function (name, label, type) { return ({
    column_name: name,
    data_type: type,
    label: label,
}); };
var CreateStandardObjectOfFilterArray = function (columnName, columnLabel, columnType, columnTypeDisplay) { return ({
    col: columnName,
    alias: columnLabel,
    kieu: columnType,
    type_display: columnTypeDisplay
}); };
var CreateObjectOfArrayListItem = function (colName, dataType, colLabel, checked) {
    if (checked === void 0) { checked = false; }
    return ({
        column_name: colName,
        data_type: dataType,
        label: colLabel,
        checked: checked,
    });
};
//# sourceMappingURL=config.js.map